import {axios, HOST, config} from './settiing';

export default {
  getObdDeviceList() {
    return axios.get(`${HOST}/resource/obdList`, config)
  },
}